import fetch from "lib/fetch";

export const sendContactRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("contact", data);
